import React from "react";

export const NEW_SITE_URL = "https://app.mashlimimplus.co.il/app";

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    boxSizing: "border-box",
    background: "linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%)",
    direction: "rtl",
    fontFamily: "inherit",
  },
  card: {
    width: "100%",
    maxWidth: 460,
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
    padding: "40px 28px",
    textAlign: "center",
  },
  logo: { width: 200, maxWidth: "70%", height: "auto", marginBottom: 24 },
  title: { margin: "0 0 12px", fontSize: 28, color: "#0f172a" },
  text: { margin: "0 0 28px", fontSize: 17, lineHeight: 1.6, color: "#475569" },
  button: {
    display: "inline-block",
    padding: "14px 32px",
    borderRadius: 10,
    background: "#1677ff",
    color: "#fff",
    fontSize: 18,
    fontWeight: 600,
    textDecoration: "none",
  },
  url: {
    display: "block",
    marginTop: 18,
    fontSize: 15,
    color: "#1677ff",
    direction: "ltr",
    wordBreak: "break-all",
  },
};

const MovedScreen = () => (
  <div style={styles.page}>
    <div style={styles.card}>
      <img src="/logo.png" alt="משלימים פלוס" style={styles.logo} />
      <h1 style={styles.title}>עברנו לכתובת חדשה!</h1>
      <p style={styles.text}>
        האתר עבר לכתובת חדשה. מעכשיו יש להיכנס דרך הכתובת:
      </p>
      <a href={NEW_SITE_URL} style={styles.button}>
        מעבר לאתר החדש
      </a>
      <a href={NEW_SITE_URL} style={styles.url}>
        app.mashlimimplus.co.il/app
      </a>
    </div>
  </div>
);

export default MovedScreen;
